<template>
  <div class="box has-text-centered content is-medium">
    <h2 v-if="confirmed">Successfully Confirmed</h2>
    <h2 v-else>Confirming your account...</h2>

    <div v-if="loading" class="loading-block my-5">
      <b-loading v-model="loading" :is-full-page="false"></b-loading>
    </div>

    <template v-if="confirmed">
      <p><span class="is-size-1">👍</span></p>
      <p>Welcome to Feedletter</p>
      <p class="has-text-centered mt-3">
        <a class="button is-primary is-medium" :href="nextStepUrl"
          >{{nextStepText}}</a
        >
      </p>
    </template>

    <p v-if="errorMsg" class="has-text-danger my-5">
      Sorry, something went wrong while confirming your account: {{ errorMsg }}
    </p>
  </div>
</template>

<script>
import {trackEvent}  from "../lib/flevents"
export default {
  name: "ConfirmationForm",
  props: {
    confirmationToken: {
      type: String,
      default: false,
    },
  },
  data: function () {
    return {
      confirmed: false,
      errorMsg: null,
      loading: false,
    };
  },
  mounted: function () {
    this.attemptConfirmation();
  },
  computed: {
    nextStepUrl() {
      if(this.$store.state.user.was_invited) {
        return "/dashboard"
      } else {
        return "/onboarding"
      }
    },
    nextStepText() {
      if(this.$store.state.user.was_invited) {
        return "Go to Dashboard"
      } else {
        return "Next Step: Quick Setup"
      }
    }
  },
  methods: {
    attemptConfirmation: function () {
      this.confirmed = false;
      this.loading = true;
      self = this;
      if (this.confirmationToken) {
        this.$store
          .dispatch("confirm", this.confirmationToken)
          .then((response) => {
            self.confirmed = true;
            self.loading = false;
            trackEvent(self.$store.state.user.id, "email_confirmed")
          })
          .catch(function (error) {
            console.log("confirm error", error);
            self.loading = false;
            if (error.responseText.trim() == "ERROR_INVALID_TOKEN") {
              self.errorMsg =
                "Unknown confirmation token. Maybe you already confirmed your account?";
            } else {
              self.errorMsg =
                "OMG, something went wrong. It was us, not you and the team was already notified. Please try again later.";
            }
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.loading-block {
  position: relative;
  margin: auto;
  width: 90%;
  height: 70px;
}
.large-icon  {
  height: 6rem !important;
}
</style>